<template>
  <div class="bg-white">
    <transition name="slide-fade">
      <mobile-menu
        v-if="isMenuOpen"
        @menu="toggleMenu"
        class="fixed lg:hidden"
      />
    </transition>
    <Header @menu="toggleMenu" ref="header" />
    <div
      ref="container"
      class="container lg:grid lg:grid-cols-4 gap-9 px-5 mt-6 mb-2 lg:mt-20"
      style="
        min-height: calc(100vh - 120px);
        transition: min-height 0.5s ease-in-out;
      "
    >
      <ProfileMenu />

      <slot />
      <template v-if="['/profile'].includes(route.path)">
        <div class="relative w-full col-span-4 mt-16 mb-12">
          <HomepageParentalSkillsBanner />
        </div>
      </template>
      <template
        v-if="!['/profile/update'].includes(route.path) && !profileStore.isVip"
      >
        <CoreFidelityNotice />
      </template>
    </div>

    <Footer ref="footer" class="px-5" />
  </div>
</template>

<script setup>
import { useProfile } from "~/store/profile";
import { useFidelityStore } from "~/store/fidelity";

import { useHeresWidget } from "~/composables/useHeresWidget";

const profileStore = useProfile();
await profileStore.getProfile();
// useHeresWidget(profileStore.profile.email);

const fidelityStore = useFidelityStore();
fidelityStore.getFidelityData();

const header = ref(null);
const footer = ref(null);
const container = ref(null);
const isMenuOpen = ref(false);

function toggleMenu(v) {
  isMenuOpen.value = v;
}

let route = useRoute();

onMounted(async () => {
  await nextTick();
  const height = header.value.$el.clientHeight + footer.value.$el.clientHeight;
  container.value.style.minHeight = "calc(100vh - " + height + "px)";
});
</script>
